import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAI1flqukmbVBxc1EKFBVY579sOWuG3LGA",
  authDomain: "iquestion-5c3c8.firebaseapp.com",
  databaseURL: "https://iquestion-5c3c8.firebaseio.com",
  projectId: "iquestion-5c3c8",
  storageBucket: "iquestion-5c3c8.appspot.com",
  messagingSenderId: "330777616582",
  appId: "1:330777616582:web:55b13bfae677d137bf37c7",
  measurementId: "G-K59LD0MK4N"
};

const firebaseConfigMagicBall = {
  apiKey: "AIzaSyCGOpo_yIbrckji0pWa_iE3u2uEQBk_Myk",
  authDomain: "magicball-f47fb.firebaseapp.com",
  databaseURL: "",
  projectId: "magicball-f47fb",
  storageBucket: "magicball-f47fb.appspot.com",
  messagingSenderId: "314492388021",
  appId: "1:314492388021:web:400d978dd7e2b8410ab4fc",
  measurementId: "G-T6D7FBP1X2"
};


export const app = firebase.initializeApp(firebaseConfig);
export const appMagicBall = firebase.initializeApp(firebaseConfigMagicBall, 'MagicBallApp');

export const auth = firebase.auth(app);
auth.languageCode = 'ru_RU';
export const providerFacebook = new firebase.auth.FacebookAuthProvider();
export const providerGoogle = new firebase.auth.GoogleAuthProvider();

export const db = firebase.firestore();
export const dbMagicBall = firebase.firestore(appMagicBall);
export const storage = firebase.storage(app);
